import type { UserProfile } from 'generated/openapi';

/**
 * Check if a user has premium subscription.
 * This function can be used in route beforeLoad (non-React context).
 *
 * @param profile - The user profile object
 * @returns true if user has premium subscription, false otherwise
 */
// TODO: migrate to use getCurrentSubscription(CustomerInfo)
export function isPremium(profile: UserProfile | undefined): boolean {
  return profile?.isPremium ?? false;
}
